import ReactController from '~/controllers/react_controller'
import AWSEKSClusterCapacityCharts from '~/dashboard/aws_eks_cluster_capacity_charts'

export default class AWSEKSClusterCapacityChartsController extends ReactController {
  static values = {
    organizationId: String,
    clusterId: String,
  }

  createComponent() {
    return <AWSEKSClusterCapacityCharts organizationId={this.organizationIdValue} clusterId={this.clusterIdValue} />
  }
}
